<template>
  <div class="analyst-shell">
    <header class="analyst-header">
      <div class="analyst-header__left">
        <img :src="sarpaLogo" alt="Sarpa Logo" class="analyst-logo" />
        <div class="analyst-titles">
          <span class="analyst-eyebrow">KERALA FOREST DEPARTMENT • SARPA</span>
          <h1 class="analyst-title">Analyst Analytics & Rescue Map</h1>
        </div>
      </div>

      <div class="analyst-header__right">
        <div class="analyst-badge">
          <span class="badge-dot"></span>
          <span class="badge-text">Analyst Portal • View Only</span>
        </div>

        <button class="analyst-logout-btn" title="Logout" @click="logout">
          <v-icon size="18" color="#ffffff">mdi-logout</v-icon>
          <span>Logout</span>
        </button>
      </div>
    </header>

    <main class="analyst-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import store from "../store";
import sarpaLogo from "../assets/sarpa-logo.png";

export default {
  name: "AnalystLayout",
  data() {
    return {
      sarpaLogo,
    };
  },
  methods: {
    logout() {
      localStorage.clear();
      store.commit("logoutUser");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.analyst-shell {
  min-height: 100vh;
  background-color: #f4f6f8;
  display: flex;
  flex-direction: column;
}

.analyst-header {
  height: 64px;
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: sticky;
  top: 0;
  z-index: 100;
}

.analyst-header__left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.analyst-logo {
  height: 38px;
  width: auto;
  object-fit: contain;
}

.analyst-titles {
  display: flex;
  flex-direction: column;
}

.analyst-eyebrow {
  font-size: 10px;
  letter-spacing: 1px;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
}

.analyst-title {
  font-size: 17px;
  font-weight: 700;
  margin: 0;
  color: #f8fafc;
  line-height: 1.2;
}

.analyst-header__right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.analyst-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(99, 102, 241, 0.15);
  border: 1px solid rgba(99, 102, 241, 0.3);
  padding: 6px 14px;
  border-radius: 20px;
}

.badge-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #10b981;
  box-shadow: 0 0 8px #10b981;
}

.badge-text {
  font-size: 12px;
  font-weight: 600;
  color: #e0e7ff;
}

.analyst-logout-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(239, 68, 68, 0.85);
  color: #ffffff;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.analyst-logout-btn:hover {
  background: #dc2626;
  transform: translateY(-1px);
}

.analyst-content {
  flex: 1;
  padding: 16px;
}
</style>
